import { Functions, httpsCallable, HttpsCallableOptions } from 'firebase/functions';

export class CrewdleFunctions {
  private functions: Functions;

  constructor(functions: Functions) {
    this.functions = functions;
  }

  public call(name: string, data = {}, callableOptions?: HttpsCallableOptions): Promise<any> {
    return httpsCallable(this.functions, name, callableOptions)(data).then((result) => result.data);
  }
}
